module.exports = __webpack_public_path__ + "img/sjjkfk.f3d1a4b5.png";